// Generated by scripts/generate-build-info.js — do not edit.
export default {
  "version": "1.0.0",
  "tag": null,
  "sha": "bdbf783",
  "branch": "master",
  "dirty": true,
  "repo": "https://gitlab.ufpe.br/thiago.prazeres/design-system-sti-ufpe",
  "commitUrl": "https://gitlab.ufpe.br/thiago.prazeres/design-system-sti-ufpe/-/commit/bdbf783",
  "tagUrl": null,
  "builtAt": "2026-05-18T06:41:19.296Z"
};
